import { render, staticRenderFns } from "./reportQuestionDetail.vue?vue&type=template&id=45fd8cb4&scoped=true"
import script from "./reportQuestionDetail.vue?vue&type=script&lang=js"
export * from "./reportQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./reportQuestionDetail.vue?vue&type=style&index=0&id=45fd8cb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd8cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fd8cb4')) {
      api.createRecord('45fd8cb4', component.options)
    } else {
      api.reload('45fd8cb4', component.options)
    }
    module.hot.accept("./reportQuestionDetail.vue?vue&type=template&id=45fd8cb4&scoped=true", function () {
      api.rerender('45fd8cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/reportQuestionDetail.vue"
export default component.exports